
import servise from '@/router/axios'



export const webReportBiddingFailList = (params) => {
    return servise({
        url:'/webReportBiddingFail/list',
        method:'get',
        params
    })
}